import React, { useState } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import parse from "html-react-parser";
const CustomTooltip = React.memo(({ text, children }) => {
  return (
    <>
      <div className="item" style={{ display: "inline-block" }}>
        <Tippy
          content={<div style={{ whiteSpace: "pre-line" }}>{parse(text)}</div>}
          placement="top"
          theme="custom"
          arrow={true}
          maxWidth={482}
          className="rounded-sm tooltip-realestates text-base"
          style={{
            zIndex: 10,
          }}
        >
          <img
            src="/images/tooltip-icon.svg"
            id="tooltip-existing-client"
            alt="tooltip"
            style={{ marginLeft: 35, height: 20 }}
            className="relative left-[-30px] clientToolTip"
          />
        </Tippy>
      </div>
    </>
  );
});
// const CustomTooltip = ({ text, children }) => {
//   const [showTooltip, setShowTooptip] = useState(false);
//   return (
//     <>
//       <img
//         src='/images/tooltip-icon.svg'
//         id='tooltip-existing-client'
//         alt='tooltip'
//         style={{ paddingLeft: 40 }}
//         className=' relative left-[-30px] clientToolTip'
//         onMouseEnter={() => setShowTooptip(true)}
//         onMouseLeave={() => setShowTooptip(false)}
//       />
//       {showTooltip && (
//         <div
//           style={{ top: 250, left: 500 }}
//           className='bg-primary-yellow-100  p-4 rounded-sm tooltip-realestates z-10 w-[482px] fixed'
//         >
//           <div className='flex flex-row'>
//             <p>
//               <div dangerouslySetInnerHTML={{ __html: text }} />
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };
export default React.memo(CustomTooltip);
